<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-laravel
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div
    v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
    ]"
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="
        this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      "
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar"
    />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />


    <configurator
      ref="configurator"
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : ''
      ]"
    />

    <div class="modal fade" id="ModalCategory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Categoria</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form>
              <div class="row">
                <div class="col-5">
                    <input type="text" v-model="category.name" id="amount" class="form-control" placeholder="Categoria">
                  </div>
                <div class="col-5">
                  <select v-model="category.parent_id" id="insumos" class="form-select" style="width:100%;">
                  <option value="" selected>Seleccionar</option>
                  <option v-for="process in parents" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
                </div>
                <div class="col-2">
                  <label for="amount" class="form-label"></label>
                  <button type="button" class="btn btn-primary" @click="submitCategory" >+</button>
                </div>
              </div>

            </form>

            <div  class="alert alert-light d-flex justify-content-between align-items-center"  role="alert" style="padding: 3px 15px;margin: 2px;"  v-for="value in categories" :key="value.id">
              {{ value.fullname }}

              <a
                  @click="deleteCategory(value.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar registro" 
                >
                <i class="fa fa-trash"></i>
              </a>
            </div>

          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCategory">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="ModalColors" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Color</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form>
              <div class="row">
                <div class="col-4">
                    <input type="text" v-model="color.name" id="" class="form-control" placeholder="Color">
                </div>
                <div class="col-4">
                    <input type="text" v-model="color.ref" id="" class="form-control" placeholder="Referencia">
                </div>
                <div class="col-4">
                  <label for="amount" class="form-label"></label>
                  <button type="button" class="btn btn-primary" @click="submitColor" >+</button>
                </div>
              </div>

            </form>

            <div  class="alert alert-light d-flex justify-content-between align-items-center"  role="alert" style="padding: 3px 15px;margin: 2px;"  v-for="value in colors" :key="value.id">
              {{ value.name }}

              <a
                  @click="deleteColors(value.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar registro" 
                >
                <i class="fa fa-trash"></i>
              </a>
            </div>

          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalColors">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="ModalTallas" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Talla</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form>
              <div class="row">
                <div class="col-8">
                    <input type="text" v-model="sizeList.size" id="" class="form-control" placeholder="Color">
                </div>
                <div class="col-4">
                  <label for="amount" class="form-label"></label>
                  <button type="button" class="btn btn-primary" @click="submitTalla" >+</button>
                </div>
              </div>

            </form>

            <div  class="alert alert-light d-flex justify-content-between align-items-center"  role="alert" style="padding: 3px 15px;margin: 2px;"  v-for="value in tallas" :key="value.id">
              {{ value.size }}

              <a
                  @click="deleteTalla(value.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar registro" 
                >
                <i class="fa fa-trash"></i>
              </a>
            </div>

          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalTallas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="ModalOficios" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Oficio</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form>
              <div class="row">
                <div class="col-8">
                    <input type="text" v-model="oficio.name" id="" class="form-control" placeholder="Oficio">
                </div>
                <div class="col-4">
                  <label for="amount" class="form-label"></label>
                  <button type="button" class="btn btn-primary" @click="submitOficio" >+</button>
                </div>
              </div>

            </form>

            <div  class="alert alert-light d-flex justify-content-between align-items-center"  role="alert" style="padding: 3px 15px;margin: 2px;"  v-for="value in oficios" :key="value.id">
              {{ value.name }}

              <a
                  @click="deleteOficios(value.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar registro" 
                >
                <i class="fa fa-trash"></i>
              </a>
            </div>

          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalOficios">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="ModalBodegas" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Bodega</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form>
              <div class="row">
                <div class="col-8">
                    <input type="text" v-model="bodega.name" id="" class="form-control" placeholder="Bodega">
                </div>
                <div class="col-4">
                  <label for="amount" class="form-label"></label>
                  <button type="button" class="btn btn-primary" @click="submitBodega" >+</button>
                </div>
              </div>

            </form>

            <div  class="alert alert-light d-flex justify-content-between align-items-center"  role="alert" style="padding: 3px 15px;margin: 2px;"  v-for="value in bodegas" :key="value.id">
              {{ value.name }}

              <a
                  @click="deleteBodegas(value.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar registro" 
                >
                <i class="fa fa-trash"></i>
              </a>
            </div>

          
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalBodegas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "App",
  data() {
    return {
      category:{
        name:'',
        parent_id:''
      },
      color:{
        name:'',
        ref:''
      },
      oficio:{
        name:'',
        description:'',
        status:1,
      },
      bodega:{
        id:0,
        name:'',
        description:'',
        status:1,
      },
      sizeList:{
        id:0,
        size:''
      },
      categories:[],
      parents:[],
      colors:[],
      oficios:[],
      bodegas:[],
      tallas:[],
    }
  },
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    closeModalCategory() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalCategory(); // Llama al método para cerrar el modal
      }
    },
    async submitCategory() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("categories/save", this.category);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getCategories();
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      this.categories.sort((a, b) => a.fullname.localeCompare(b.fullname));
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async deleteCategory(id) {
      const response = await this.$store.dispatch("categories/delete",id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
            this.getCategories();
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
      
    },
    async submitColor() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("colors/save", this.color);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getColors();
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async getColors() {
      const response = await this.$store.dispatch("colors/getColors");
      this.colors = response.data;
    },
    async deleteColors(id) {
      const response = await this.$store.dispatch("colors/delete",id);
   
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
            this.getColors();
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalColors() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalColors(); // Llama al método para cerrar el modal
      }
    },
    async submitOficio() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("oficios/save", this.oficio);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getOficios();
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async getOficios() {
      const response = await this.$store.dispatch("oficios/getOficios");
      this.oficios = response.data;
    },
    async deleteOficios(id) {
      const response = await this.$store.dispatch("oficios/delete",id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
            this.getOficios();
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalOficios() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalOficios(); // Llama al método para cerrar el modal
      }
    },

    async submitBodega() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("bodegas/save", this.bodega);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getBodegas();
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async getBodegas() {
      const response = await this.$store.dispatch("bodegas/getAll");
      // Ordenar bodegas por nombre ascendente
      this.bodegas = response.sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    },
    async deleteBodegas(id) {
      const response = await this.$store.dispatch("bodegas/delete",id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
            this.getBodegas();
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalBodegas() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalBodegas(); // Llama al método para cerrar el modal
      }
    },

    async submitTalla() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("tallas/save", this.sizeList);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getTallas();
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.tallas = response;
    },
    async deleteTalla(id) {
      const response = await this.$store.dispatch("tallas/delete",id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
            this.getTallas();
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalTallas() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalTallas(); // Llama al método para cerrar el modal
      }
    },
  },
  computed: {
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  mounted(){

    let user = JSON.parse(localStorage.getItem('user'));

    // Verificar si el usuario existe
    if (user) {

      this.getBodegas();
      /* this.getCategories();
      this.getColors();
      this.getOficios();
     
      this.getTallas(); */
    } else {
        console.log("No se encontró un usuario en el localStorage.");
        // Opcional: redirigir al login o mostrar un mensaje
    }
  }
};
</script>
